<script lang="ts">
  import { _ } from 'svelte-i18n';
  export let isAppActive = true;
  export let isStartingInFuture = false;
</script>

<div class="bg-black">
  <div
    class="mx-auto flex max-w-7xl items-center justify-center px-4 py-4 text-center sm:px-6 sm:py-6"
  >
    <h1
      class="font-CorpoA text-2xl leading-tight text-white sm:text-5xl"
    >
      {#if isStartingInFuture && !isAppActive}
        {$_('MBD Purchase Payback Registration Future')}
      {:else}
        {$_('MBD Purchase Payback Registration')}
      {/if}
    </h1>
  </div>
</div>
